export default __webpack_public_path__ + "static/media/icon-coin-dodo.dc38db77.svg";